
const secondInfo ={
  path: '/Secondhand/secondInfo',
  component: resolve => require(['@/views/Secondhand/secondInfo'], resolve),
  name: 'secondInfo',
  meta: {title: '二手工具信息'}
};
const toolAudit = {
  path: '/Secondhand/toolAudit',
  component: resolve => require(['@/views/Secondhand/toolAudit'], resolve),
  name: 'toolAudit',
  meta: {title: '工具信息审核'}
};
const secondComment =  {
  path: '/Secondhand/secondComment',
  component: resolve => require(['@/views/Secondhand/secondComment'], resolve),
  name: 'secondComment',
  meta: {title: '二手工具评论'}
};
const nearWorker =  {
  path: '/Secondhand/nearWorker',
  component: resolve => require(['@/views/Secondhand/nearWorker'], resolve),
  name: 'nearWorker',
  meta: {title: '附近工友管理'}
};
const WorkerAudit =  {
  path: '/Secondhand/WorkerAudit',
  component: resolve => require(['@/views/Secondhand/WorkerAudit'], resolve),
  name: 'WorkerAudit',
  meta: {title: '附近工友审核'}
};
const workerComment =  {
  path: '/Secondhand/workerComment',
  component: resolve => require(['@/views/Secondhand/workerComment'], resolve),
  name: 'workerComment',
  meta: {title: '附近工友评论'}
};
const creditLog =  {
  path: '/Secondhand/creditLog',
  component: resolve => require(['@/views/Secondhand/creditLog'], resolve),
  name: 'creditLog',
  meta: {title: '信用管理'}
}
const creditAudit =  {
  path: '/Secondhand/creditAudit',
  component: resolve => require(['@/views/Secondhand/creditAudit'], resolve),
  name: 'creditAudit',
  meta: {title: '信用审核'}
};
export default [secondInfo,toolAudit,secondComment,nearWorker,WorkerAudit,workerComment,creditLog,creditAudit]




// WEBPACK FOOTER //
// ./src/router/modules/Secondhand.js